// API Configuration
const config = {
  // API Gateway URL - this will be updated after deployment
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://xytc9rgf6f.execute-api.us-west-2.amazonaws.com/prod',
  
  // API Key - this will be set after deployment
  API_KEY: process.env.REACT_APP_API_KEY || 'wuTig2bF6N6lU6Jg8aB4paOcmNS2a0CL1HgoFVlA',
  
  // Google OAuth Configuration
  GOOGLE_CLIENT_ID: '981110436825-sbaecgetipaa5fo80p9t6l32lpjdjsh1.apps.googleusercontent.com',
  
  // Default headers for API requests
  getDefaultHeaders: function() {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    // Add API key if available
    if (this.API_KEY) {
      headers['x-api-key'] = this.API_KEY;
    }
    
    return headers;
  },
  
  // Helper function to make API requests
  apiRequest: async function(endpoint, options = {}) {
    const url = `${this.API_BASE_URL}${endpoint}`;
    const defaultOptions = {
      headers: this.getDefaultHeaders(),
    };
    
    const finalOptions = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers,
      },
    };
    
    return fetch(url, finalOptions);
  }
};

export default config;
